const globalFeatureFlags = {
    PRODUCTS_ZONE: 'productszone',
    FACTURA_ELECTRONICA: 'facturaelectronica',
    ONLINE_PAYMENT: 'onlinepayment',
    ONLINE_STORE: 'onlinestore',
    EVENTS: 'events',
    BLOG: 'blog',
    GOOGLE_ANALYTICS: 'googleanalytics',
    APPOINTMENTS: 'appointments',
    MEMBERSHIPS: 'memberships',
};

export default globalFeatureFlags;
